import { version } from '../system/version.js'

export const currentVersion = version
